import { render, staticRenderFns } from "./ItemLayout.vue?vue&type=template&id=4f395472&scoped=true"
import script from "./ItemLayout.vue?vue&type=script&lang=js"
export * from "./ItemLayout.vue?vue&type=script&lang=js"
import style0 from "./ItemLayout.vue?vue&type=style&index=0&id=4f395472&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f395472",
  null
  
)

export default component.exports